import { render, staticRenderFns } from "./liaobantest.vue?vue&type=template&id=db32bc24&scoped=true&"
import script from "./liaobantest.vue?vue&type=script&lang=js&"
export * from "./liaobantest.vue?vue&type=script&lang=js&"
import style0 from "./liaobantest.vue?vue&type=style&index=0&id=db32bc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db32bc24",
  null
  
)

export default component.exports